import {
    showOrderItemAddressSelectionDisplay
} from './_showOrderItemAddressSelectionDisplay';
import {
	showStorePickupTopDisplay
} from './_showStorePickupTopDisplay';
import {
	showStorePickupHeader
} from './_showStorePickupHeader';

const addressRadio = (selectOption, selectAddress, firstOption) => {
	showOrderItemAddressSelectionDisplay(false);
    selectOption.each(function() {
        selectAddress.removeProp('selected');
    });
    if (navigator.userAgent.match(/iphone|ipad/i)) firstOption.prop('selected', 'selected');
    else {
        firstOption.prop('selected', 'selected');
        firstOption.attr('selected', 'selected');
    }
}

const allDevicesRegistryAddressRadio = () => {
    $('#display-registry-addresses-radio').change(function() {
    	if ($(this).prop("checked") == true){
    		$('input[name=pickupSelected]').val('false');
        $('#holdAtLocationInputs').hide();
        $('#holdAtLocationPickupNames').hide();
        $('#optInText').hide();
        $('address.address-checkout-hal, #changeHalLocation, #updateHalName').hide();
        $('#holdAtLocationPickupNames').removeClass('open');
    		addressRadio($('.shipping-select option'), $("[class^=SelectAddress_]"), $(".shipping-select option:first"))
    	}
    });
};

const allDevicesHoldAtLocationRadio = () => {
  $('#display-hold-at-locaiton-radio').change(function() {
     if ($(this).prop("checked") == true){
       // $('#holdAtLocationSearchHidden').click();
       $('#holdAtLocationInputs').show();
       $('input[name=pickupSelected]').val('false');
       Dillards.showStorePickupTopDisplay(false);
			 Dillards.showStorePickupHeader(false);
       $('#optInText, #storePickUpStoreInfo, #storeShippingMessage').hide();
       addressRadio($('.shipping-select option'), $("[class^=SelectAddress_]"), $(".shipping-select option:first"), $(".registry-select option:first"))
     }
  });
};


const allDevicesCurbsideRadio = () => {
    $('#display-curbside-radio').change(function() {
       if ($(this).prop("checked") == true){
         // $('#holdAtLocationSearchHidden').click();
         $('#holdAtLocationInputs').show();
         $('input[name=pickupSelected]').val('false');
         Dillards.showStorePickupTopDisplay(false);
         Dillards.showStorePickupHeader(false);
         $('#optInText, #storePickUpStoreInfo, #storeShippingMessage').hide();
         addressRadio($('.shipping-select option'), $("[class^=SelectAddress_]"), $(".shipping-select option:first"), $(".registry-select option:first"))
       }
    });
  };


const allDevicesShippingSavedAddressRadio = () => {
    if ($('#display-saved-addresses-radio').prop("checked")){
    	$('input[name=pickupSelected]').val('false');
      $('#holdAtLocationInputs').show();
       $('#holdAtLocationPickupNames').show();
      $('#holdAtLocationInputs').hide();
      $('#holdAtLocationPickupNames').hide();
      $('#optInText').hide();
      $('address.address-checkout-hal, #changeHalLocation, #updateHalName').hide();
      $('#holdAtLocationPickupNames').removeClass('open');
    	addressRadio($('.registry-select option'), $("[class^=SelectRegistryAddress_]"), $(".registry-select option:first"));
    }
};

const allDevicesQcOrBillingAddressRadioSelected = () => {
	$('input[name=pickupSelected]').val('false');
	showStorePickupTopDisplay(false);
	showStorePickupHeader(false);
  $('#holdAtLocationInputs').hide();
  $('#holdAtLocationPickupNames').hide();
  $('#optInText').hide();
  $('address.address-checkout-hal, #changeHalLocation, #updateHalName').hide();
  $('#holdAtLocationPickupNames').removeClass('open');
	$('.shipping-select option').each(function() {
        $("[class^=SelectAddress_]").removeProp('selected');
    });
    $('.registry-select option').each(function() {
        $("[class^=SelectRegistryAddress_]").removeProp('selected');
    });
    if (navigator.userAgent.match(/iphone|ipad/i)) {
        $(".shipping-select option:first").prop('selected', 'selected');
        $(".registry-select option:first").prop('selected', 'selected');
    } else {
        $(".shipping-select option:first").prop('selected', 'selected');
        $(".shipping-select option:first").attr('selected', 'selected');
        $(".registry-select option:first").prop('selected', 'selected');
        $(".registry-select option:first").attr('selected', 'selected');
    }
};

export {
    allDevicesRegistryAddressRadio,
    allDevicesShippingSavedAddressRadio,
    allDevicesQcOrBillingAddressRadioSelected,
    allDevicesHoldAtLocationRadio,
    allDevicesCurbsideRadio
}
